<div class="alert alert-info border-blue m-b-0 m-t-10" role="alert"
    style="border: 2px solid #31708f; border-radius: 4px !important; display: flow-root; font-size: 18px;">
    <i class="fa fa-lg fa-info-circle" style="float: left; margin-right: 10px; margin-top: 4px;"></i>
    <p>When entering an address please select an option from the autocomplete list provided. If you can not find your
        address, click 'Enter address manually' </p>
</div>